import { faEnvelope } from '@fortawesome/pro-light-svg-icons/faEnvelope'
import { faPhone } from '@fortawesome/pro-light-svg-icons/faPhone'
import React, { useRef } from 'react'

import { HOMEPAGE, NAV_BRAND } from '@/config'
import { FOOTER_LOGO, FOOTER_PHONE, FOOTER_PHONE_AT, FOOTER_NAV } from '@/config/rja/constants'

import useCountryShorthand from '../hooks/useCountryShorthand'

import IconLink from './IconLink'
import SocialIcon from './SocialIcon'

const StaticFooter = () => {
  const { rja: { staticFooterImages: { social }, sealImages } } = HOMEPAGE
  const phone = NAV_BRAND.portal_is_at ? FOOTER_PHONE_AT : FOOTER_PHONE
  const { current: displayPhone } = useRef(phone.replace(/-/g, ' '))
  const currentYear = new Date().getFullYear()
  const country = useCountryShorthand()
  const email = `anfrage@regio-jobanzeiger.${country}`
  return (
    <footer className='rja-footer'>
      <div className='footer-sections-container'>
        <div className='footer-section footer-section-contacts'>
          <div className='logo'>
            <img src={FOOTER_LOGO} alt='Regio Jobanzeiger' />
          </div>
          <div className='contact-block'>
            <span>Welfenstr. 22</span>
            <br />
            <span>81541 München</span>
          </div>
          <div className='section-block'>
            <h3>Informationen</h3>
            <IconLink className='qa-phone' icon={faPhone} href={`tel:${phone}`} rel='noopener noreferrer'>
              <span className='info-label'>{displayPhone}</span>
            </IconLink>
            <IconLink
              className='info-email'
              icon={faEnvelope}
              href={`mailto:${email}?subject=Kontaktanfrage über ${window.location.origin}`}
              rel='noopener noreferrer'
            >
              <span className='info-label'>{email}</span>
            </IconLink>
          </div>
        </div>
        <div className='footer-section footer-section-socials'>
          {social.map(({ icon, href }) => (
            <SocialIcon key={icon} icon={icon} href={href} />
          ))}
        </div>
        <div className='footer-section footer-section-companies'>
          <h3>Unternehmen</h3>
          <ul>
            <li className='section-list-item'>
              <a href={`https://www.regio-jobanzeiger.${country}/unternehmen/`} target='_blank' rel='noreferrer noopener'>Über Regio Jobanzeiger</a>
            </li>
            <li className='section-list-item'>
              <a href={`https://www.regio-jobanzeiger.${country}/unternehmen/#stellenausschreibungen`} target='_blank' rel='noreferrer noopener'>Karriere</a>
            </li>
            <li className='section-list-item'>
              <a href={`https://www.regio-jobanzeiger.${country}/presse/`} target='_blank' rel='noreferrer noopener'>Presse</a>
            </li>
          </ul>
        </div>
        <div className='footer-section footer-section-products'>
          <h3>Unsere Produkte</h3>
          <a href={`https://www.regio-jobanzeiger.${country}/produkte/#produktuebersicht`} target='_blank' rel='noreferrer noopener'>Produktübersicht</a>
        </div>
      </div>
      <div className='footer-rewards'>
        {sealImages.map((imageUrl) => (
          <img key={imageUrl} className='reward-image' src={imageUrl} />
        ))}
      </div>
      <nav className='footer-nav'>
        <li className='nav-item copyrights'>
          <span>© {currentYear} Regio-Jobanzeiger GmbH & Co.KG</span>
        </li>
        {FOOTER_NAV.map(({ title, href }) => (
          <li key={title} className='nav-item'>
            <a
              href={href} title={title} rel='nofollow'
              className='nav-link'
            >
              {title}
            </a>
          </li>
        ))}
      </nav>
    </footer>
  )
}

export default StaticFooter
